import {
  Button,
  ModalContent,
  ModalFooter,
  ModalHeaderWithIcon,
} from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import type { AuthenticationMethod } from 'src/auth/modules/StrongCustomerAuthentication/models/factors';

type Props = {
  hasRecoveryMethod: boolean;
  onCancel: () => void;
  onNext: (authenticationMethod: AuthenticationMethod) => Promise<void>;
};

export const ContactAdminModal = ({
  hasRecoveryMethod,
  onCancel,
  onNext,
}: Props) => {
  const { t } = useTranslation('auth');

  return (
    <ModalContent>
      <ModalHeaderWithIcon
        title={t('sca.contactAdminModal.title')}
        subtitle={t('sca.contactAdminModal.description')}
        iconName="lock-close"
        iconVariant="neutral"
        titleId="select-auth-factor-modal-title"
      />
      <ModalFooter>
        <Button
          variant="secondaryNeutral"
          text={t('misc.cancel')}
          onClick={onCancel}
        />
        <Button
          variant="primaryBrand"
          text={t('sca.contactAdminModal.cta')}
          isDisabled={!hasRecoveryMethod}
          onClick={() => onNext('RECOVERY')}
        />
      </ModalFooter>
    </ModalContent>
  );
};
